module.exports = __webpack_public_path__ + "static/media/quizBeeImg.79460164.png";